import { PlateTypeEnum } from './cutting-panel-outline.model';

export interface CuttingPanelBaseSlot {
  id: number;
  name: string;
  designation: string;
  h: number;
  g: number;
  dx: number;
  fi: number;
  b: number;
  r: number;
  type: GrooveTypeEnum;
  custom: boolean;
  plate: PlateTypeEnum;
}

export enum GrooveTypeEnum {
  InPlate,
  InSide,
  Rabbet,
  Chamfer,
  Fillet,
  Chamfer2,
}
